var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DepartmentTree from "~/components/system-manage/department-tree.vue";
import { Prop, Emit } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { UserService } from "~/services/management-service/user.service";
import { VisitCaseManageService } from "~/services/domain-service/visit-case-manage.service";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
import { LegalCaseManageService } from "~/services/domain-service/legal-case-manage.service";
import { CaseAssitVisitStayService } from "~/services/domain-service/case-assist-visit-stay.service";
import { RepairCasesService } from "~/services/domain-service/repair-cases.service";
import { CaseAssistAntiFraudCaseStayService } from '~/services/domain-service/case-assist-anti-fraud-case-stay.service';
import { CaseAssistAntiFraudSurveyCaseService } from "~/services/domain-service/case-assist-anti-fraud-survey-case.service";
import { CaseAssistService } from '~/services/domain-service/case-assist.service';
import Distribution from "~/components/distribution-common/distribution.vue";
import MessageBution from "~/components/distribution-common/message-bution.vue";
import { namespace, Getter } from "vuex-class";
import { CASE_CHANNEL } from "~/config/enum.config";
var AllotModule = namespace("case-allot");
var CaseAllot = /** @class */ (function (_super) {
    __extends(CaseAllot, _super);
    function CaseAllot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selectionList = [];
        _this.userDataSet = [];
        _this.nowNode = null;
        _this.personalCollectionDays = null;
        _this.distributionData = {};
        _this.submitLoading = false;
        _this.collectionType = "";
        _this.dialog = false;
        _this.dialogMessage = false;
        _this.DepartmentData = null;
        _this.currentDept = '';
        return _this;
    }
    Object.defineProperty(CaseAllot.prototype, "isShow", {
        get: function () {
            var arr = [CASE_CHANNEL.assist_tel, CASE_CHANNEL.assist_visit, CASE_CHANNEL.assist_legal];
            return !arr.includes(this.fromChannel) && this.allotType === 'TO_COLLECTOR';
        },
        enumerable: false,
        configurable: true
    });
    CaseAllot.prototype.emitRefreshList = function () { };
    CaseAllot.prototype.emitClose = function () {
        this.dialogMessage = false;
        this.dialog = false;
        this.resetState();
        this.currentDept = '';
        this.updateDeptIds();
        this.updateUserIds([]);
        this.emitRefreshList();
        this.nowNode = null;
        this.DepartmentData = null;
        this.personalCollectionDays = null;
        this.allotType = 'TO_COLLECTOR';
    };
    // @Watch("fromChannel", { immediate: true })
    CaseAllot.prototype.refreshDept = function () {
        this.pageService.reset();
        this.userDataSet = [];
        if (!this.fromChannel)
            return;
        switch (this.fromChannel) {
            case CASE_CHANNEL.tel:
            case CASE_CHANNEL.assist_tel:
                this.DepartmentData = this.callDepartmentData;
                break;
            case CASE_CHANNEL.legal:
            case CASE_CHANNEL.assist_legal:
                this.DepartmentData = this.legalDepartmentData;
                break;
            case CASE_CHANNEL.visit:
            case CASE_CHANNEL.assist_visit:
                this.DepartmentData = this.visitDepartmentData;
                break;
            case CASE_CHANNEL.CREDIT_REPAIR:
                this.DepartmentData = this.creditRepairDepartmentDataNoRoot;
                break;
            case CASE_CHANNEL.law:
                this.DepartmentData = this.lawDepartmentDataNoRoot;
                break;
            case CASE_CHANNEL.fraud:
                this.DepartmentData = this.cheatDepartmentDataNoRoot;
                break;
        }
    };
    Object.defineProperty(CaseAllot.prototype, "display", {
        get: function () {
            return this.allotType === "TO_DEPARTMENT" ? "" : this.selectionList;
        },
        set: function (v) {
            this.selectionList = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CaseAllot.prototype, "allotType", {
        get: function () {
            return this.category;
        },
        set: function (val) {
            this.updateCategory(val);
            this.display = [];
        },
        enumerable: false,
        configurable: true
    });
    // private get currentDept() {
    //   return this.distributeModel.deptIds[0];
    // }
    // private set currentDept(val) {
    //   this.updateDeptIds(val.id);
    //   this.refreshData(val.deptCode);
    // }
    /**
     * 获取当前树选择项
     */
    CaseAllot.prototype.getCheckedNodes = function (item) {
        if (this.nowNode && item.deptCode === this.nowNode.deptCode) {
            return;
        }
        this.pageService.reset();
        this.currentDept = item;
        this.updateDeptIds(item.id);
        this.refreshData();
    };
    //按机构分配
    CaseAllot.prototype.submit = function () {
        var _this = this;
        if (!this.currentDept) {
            this.$message.error("请选择部门");
            return false;
        }
        this.updatePersonalCollectionDays('');
        var service = null;
        switch (this.fromChannel) {
            case CASE_CHANNEL.tel:
                service = this.telCaseManageService;
                break;
            case CASE_CHANNEL.visit:
                service = this.visitCaseManageService;
                break;
            case CASE_CHANNEL.legal:
                service = this.legallyCaseManageServiceTestA;
                break;
            case CASE_CHANNEL.assist:
            case CASE_CHANNEL.assist_tel:
            case CASE_CHANNEL.assist_visit:
            case CASE_CHANNEL.assist_legal:
                service = this.caseAssistService;
                break;
            case CASE_CHANNEL.CREDIT_REPAIR:
                service = this.repairCasesService;
                break;
            case CASE_CHANNEL.law:
                service = this.caseAssitVisitStayService;
                break;
            case CASE_CHANNEL.fraud:
                service = this.caseAssistAntiFraudCaseStayService;
                break;
        }
        if (!service) {
            console.error("分配服务参数配置错误...");
            this.$message.error("案件分配异常");
            return;
        }
        this.submitLoading = true;
        service.confirmDistributeCase(this.distributeModel).subscribe(function (data) {
            _this.success();
            _this.submitLoading = false;
        }, function () { return (_this.submitLoading = false); });
    };
    CaseAllot.prototype.refreshData = function () {
        var _this = this;
        var model = {
            deptCode: this.currentDept.deptCode,
            caseSwitch: "ENABLED"
        };
        this.userService
            .getAllUsers(model, this.pageService)
            .subscribe(function (data) { return (_this.userDataSet = data); });
    };
    CaseAllot.prototype.next = function () {
        var _this = this;
        if (this.isShow) {
            if (!this.personalCollectionDays || this.personalCollectionDays <= 0) {
                return this.$message.error('请输入催收天数！');
            }
            // 更新催收天数
            this.updatePersonalCollectionDays(this.personalCollectionDays);
            // 查询最大催收天数
            this.telCaseManageService
                .getRemainingPartCollectionDays(this.distributeModel.caseIds)
                .subscribe(function (data) {
                if (data && _this.personalCollectionDays > data) {
                    return _this.$message.error('催收天数不能大于最小部门剩余天数' + data + '天！');
                }
                else {
                    _this.updateDebtState(false);
                    _this.updateMode("BY_INTEGRATE");
                    if (_this.fromChannel === CASE_CHANNEL.CREDIT_REPAIR) {
                        _this.dialogMessage = true;
                    }
                    else {
                        var userIds = _this.selectionList.map(function (v) { return v.id; });
                        _this.updateUserIds(userIds);
                        _this.dialog = true;
                    }
                }
            });
        }
        else {
            this.updateDebtState(false);
            this.updateMode("BY_INTEGRATE");
            if (this.fromChannel === CASE_CHANNEL.CREDIT_REPAIR) {
                this.dialogMessage = true;
            }
            else {
                var userIds = this.selectionList.map(function (v) { return v.id; });
                this.updateUserIds(userIds);
                this.dialog = true;
            }
        }
    };
    CaseAllot.prototype.success = function () {
        this.$message.success("分配成功");
        this.emitClose();
        this.emitRefreshList();
    };
    __decorate([
        Dependencies(RepairCasesService)
    ], CaseAllot.prototype, "repairCasesService", void 0);
    __decorate([
        Dependencies(PageService)
    ], CaseAllot.prototype, "pageService", void 0);
    __decorate([
        Dependencies(UserService)
    ], CaseAllot.prototype, "userService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], CaseAllot.prototype, "telCaseManageService", void 0);
    __decorate([
        Dependencies(VisitCaseManageService)
    ], CaseAllot.prototype, "visitCaseManageService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], CaseAllot.prototype, "legallyCaseManageServiceTestA", void 0);
    __decorate([
        Dependencies(CaseAssitVisitStayService)
    ], CaseAllot.prototype, "caseAssitVisitStayService", void 0);
    __decorate([
        Dependencies(CaseAssistAntiFraudCaseStayService)
    ], CaseAllot.prototype, "caseAssistAntiFraudCaseStayService", void 0);
    __decorate([
        Dependencies(CaseAssistService)
    ], CaseAllot.prototype, "caseAssistService", void 0);
    __decorate([
        Dependencies(CaseAssistAntiFraudSurveyCaseService)
    ], CaseAllot.prototype, "caseAssistAntiFraudSurveyCaseService", void 0);
    __decorate([
        Getter
    ], CaseAllot.prototype, "callDepartmentData", void 0);
    __decorate([
        Getter
    ], CaseAllot.prototype, "visitDepartmentData", void 0);
    __decorate([
        Getter
    ], CaseAllot.prototype, "legalDepartmentData", void 0);
    __decorate([
        Getter
    ], CaseAllot.prototype, "creditRepairDepartmentDataNoRoot", void 0);
    __decorate([
        Getter
    ], CaseAllot.prototype, "lawDepartmentDataNoRoot", void 0);
    __decorate([
        Getter
    ], CaseAllot.prototype, "cheatDepartmentDataNoRoot", void 0);
    __decorate([
        AllotModule.State
    ], CaseAllot.prototype, "category", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updateCategory", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updateDeptIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updateUserIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updateCaseIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updateDebtState", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updateMode", void 0);
    __decorate([
        AllotModule.Getter
    ], CaseAllot.prototype, "distributeModel", void 0);
    __decorate([
        AllotModule.Action
    ], CaseAllot.prototype, "resetState", void 0);
    __decorate([
        AllotModule.Mutation
    ], CaseAllot.prototype, "updatePersonalCollectionDays", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], CaseAllot.prototype, "fromChannel", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], CaseAllot.prototype, "again", void 0);
    __decorate([
        Emit("refreshList")
    ], CaseAllot.prototype, "emitRefreshList", null);
    __decorate([
        Emit("close")
    ], CaseAllot.prototype, "emitClose", null);
    CaseAllot = __decorate([
        Component({
            components: {
                DepartmentTree: DepartmentTree,
                Distribution: Distribution,
                MessageBution: MessageBution
            }
        })
    ], CaseAllot);
    return CaseAllot;
}(Vue));
export default CaseAllot;
